import * as React from "react";

import { DestinationHeroDefault } from "./views/DestinationHeroDefault";
import { DestinationHeroGallery } from "./views/DestinationHeroGallery";

import { DestinationHeroProps } from "./typings";

export enum Sources {
  Trover = "Trover",
  Wikimedia = "Wikimedia"
}

export enum ModelView {
  Wizard = "wizard",
  Gallery = "gallery"
}

export const DestinationHero = (props: DestinationHeroProps) => {
  const { flexComponent, context } = props;
  const model = flexComponent && flexComponent.model;
  const content = model && model.content;

  if (!model || model.empty || !content) {
    return null;
  }

  return model.view === ModelView.Gallery ? (
    <DestinationHeroGallery flexComponent={flexComponent} context={context} />
  ) : (
    <DestinationHeroDefault flexComponent={flexComponent} context={context} />
  );
};

export default DestinationHero;
